import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage} from "firebase/messaging";

// const firebaseConfig = {
//   apiKey: "YOUR_API_KEY",
//   authDomain: "YOUR_AUTH_DOMAIN",
//   projectId: "YOUR_PROJECT_ID",
//   storageBucket: "YOUR_STORAGE_BUCKET",
//   messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
//   appId: "YOUR_APP_ID",
// };
const firebaseConfig = {
    apiKey: "AIzaSyC4MFVtjLINDzEyNu-7ffXlg5MzG3FPYPo",
    authDomain: "friends-bd5cb.firebaseapp.com",
    projectId: "friends-bd5cb",
    storageBucket: "friends-bd5cb.firebasestorage.app",
    messagingSenderId: "901075387373",
    appId: "1:901075387373:web:eafbc791911e5b55a31de4",
    measurementId: "G-WKW89MW31D"
  };
  

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export { messaging, getToken, onMessage };
